function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "80%",
  y1: "0%",
  x2: "20%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E95D26",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C02227",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Izv\\u0113lies-savu-instruktoru-(Karti\\u0146as)",
  transform: "translate(-318.000000, -620.000000)",
  fill: "url(#linearGradient-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Page-content",
  transform: "translate(294.000000, 136.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Details",
  transform: "translate(24.000000, 322.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Price",
  transform: "translate(0.000000, 156.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 Z M13.1176471,6 C13.5829179,6 14.0961929,6.05763796 14.657472,6.17291388 L15,6.24899598 L14.7128614,8.20080321 L14.4139182,8.10827309 C14.0166035,7.99860776 13.6243935,7.9437751 13.2372881,7.9437751 C11.7978962,7.9437751 10.9812309,8.65171587 10.7872922,10.0675974 L10.7647059,10.2650602 L13.4207378,10.2650602 L13.4207378,11.4859438 L10.7487537,11.4859438 L10.7487537,12.4819277 L13.4207378,12.4819277 L13.4207378,13.7028112 L10.7487537,13.7028112 L10.7621934,13.9330924 C10.8189033,14.6063454 11.0231306,15.1212851 11.3748754,15.4779116 C11.7657029,15.8741633 12.3732137,16.0722892 13.1974078,16.0722892 C13.6626786,16.0722892 14.0910232,16.0146512 14.4824416,15.8993753 L14.7128614,15.8232932 L15,17.7670683 L14.6018345,17.8509237 C14.067544,17.9503079 13.5196411,18 12.9581256,18 C11.5596544,18 10.4523097,17.6211513 9.63609172,16.8634538 C8.87428825,16.1562695 8.44946494,15.1913669 8.3616218,13.9687461 L8.34795613,13.7028112 L7,13.7028112 L7,12.4819277 L8.34795613,12.4819277 L8.34795613,11.4859438 L7,11.4859438 L7,10.2650602 L8.36390828,10.2650602 L8.38700343,9.99919679 C8.51818914,8.7772423 8.97709095,7.81767068 9.76370887,7.12048193 C10.6065138,6.37349398 11.7244932,6 13.1176471,6 Z",
  id: "icon"
})))))));

function SvgIcInstructorsPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "761101BC-DB61-435A-A06F-278FCBA3D8FF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstructorsPrice);
export default __webpack_public_path__ + "static/media/ic-instructors-price.f2e32fe4.svg";
export { ForwardRef as ReactComponent };